type ResizablePanelHandleProps = {
  onMouseDown: () => void;
};

export const ResizablePanelHandle = ({ onMouseDown }: ResizablePanelHandleProps) => (
  <div
    className="absolute inset-y-0 -left-1.5 z-10 flex w-3 cursor-col-resize items-center justify-center"
    onMouseDown={onMouseDown}
  >
    <div className="flex h-6 w-3 items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 active:bg-gray-400">
      <svg width="7" height="11" viewBox="0 0 7 11" fill="currentColor" className="text-gray-600">
        <circle cx="1.75" cy="1.25" r="1.5" />
        <circle cx="5.25" cy="1.25" r="1.5" />
        <circle cx="1.75" cy="5.5" r="1.5" />
        <circle cx="5.25" cy="5.5" r="1.5" />
        <circle cx="1.75" cy="9.75" r="1.5" />
        <circle cx="5.25" cy="9.75" r="1.5" />
      </svg>
    </div>
  </div>
);
